import { api } from "@/lib/api";
import { plur } from "@/lib/format";
import { ask } from "@/lib/confirm";
import { addMonths, monthEnd, monthLabel, monthStart, todayIso } from "@/lib/absences";

// 403: stažení šichtovnice a podkladu pro mzdy z menu ⋯ (Docházka) a z Ekonomiky (účetní Docházku nemá).
// Období = co je otevřené v Šichtovnici nebo ve filtru Od–Do. Částky jen majitel, asistentka a účetní.
export const PAY_ROLES = ["OWNER", "ASSISTANT", "ACCOUNTANT"];
export const SHEET_ROLES = ["OWNER", "MANAGER", "ASSISTANT", "ACCOUNTANT"];

// Mzdy se dělají začátkem dalšího měsíce — do 15. minulý měsíc, potom aktuální.
export const payrollMonth = (today = todayIso()) => (Number(today.slice(8, 10)) <= 15 ? addMonths(today, -1) : monthStart(today));

// Ekonomika: Od–Do v měsících („2026-10“). Jeden nebo dva měsíce = ty, delší období = měsíc pro mzdy.
export function rangeOfMonths(od, doM, today = todayIso()) {
  if (od && doM && od <= doM && addMonths(`${od}-01`, 1) >= `${doM}-01`) return { date_from: `${od}-01`, date_to: monthEnd(`${doM}-01`) };
  const m = payrollMonth(today);
  return { date_from: m, date_to: monthEnd(m) };
}

export const rangeLabel = (r, czDate = (x) => x) => (r.date_from === monthStart(r.date_from) && r.date_to === monthEnd(r.date_from)
  ? monthLabel(r.date_from) : `${czDate(r.date_from)} – ${czDate(r.date_to)}`);

// Stáhne šichtovnici (fmt pdf / xlsx / csv, money = s částkami). Před stažením zkontroluje nevyplněné pracovní dny
// a zeptá se — účetní by dostala neúplné podklady (402).
export async function downloadSheet({ range, label, fmt, money = false, run, fillHint }) {
  const p = new URLSearchParams({ fmt, date_from: range.date_from, date_to: range.date_to });
  if (range.user_ids?.length) p.set("user_ids", range.user_ids.join(","));
  try {
    const q = new URLSearchParams(p); q.delete("fmt");
    const { data: sh } = await api.get(`/absences/sheet?${q.toString()}`);
    if (sh?.missing > 0 && !(await ask("", { title: `Šichtovnice za ${label.charAt(0).toLowerCase()}${label.slice(1)} není kompletní`,
      description: `Nevyplněno ${plur(sh.missing, "pracovní den", "pracovní dny", "pracovních dní")} — bez docházky i nepřítomnosti. Účetní by dostala neúplné podklady. ${fillHint || "Doplníte je v Šichtovnici klepnutím na den s otazníkem."}`,
      ok: "Stáhnout přesto", cancel: "Zpět", danger: false }))) return;
  } catch { /* kontrola se nepovedla — stáhnout i tak */ }
  if (money) p.set("money", "1");
  const name = `${money ? "podklad_mzdy" : "sichtovnice"}_${range.date_from.slice(0, 7)}.${fmt}`;
  run(`sheet-${fmt}${money ? "-money" : ""}`, `/api/absences/sheet/export?${p.toString()}`, name, money ? "Připravuji podklad pro mzdy…" : "Připravuji šichtovnici…");
}

// Položky menu ⋯: Šichtovnice PDF / Excel / CSV a pro majitele, asistentku a účetní oddíl S částkami.
export function sheetMenuItems({ label, canMoney, onPick, icons }) {
  const { pdf, xlsx, csv, money } = icons;
  const items = [
    { icon: pdf, label: "Šichtovnice PDF", hint: `${label} · k tisku a podpisu`, onClick: () => onPick("pdf", false), testid: "export-sheet-pdf" },
    { icon: xlsx, label: "Šichtovnice Excel", hint: `${label} · podklad pro mzdy`, onClick: () => onPick("xlsx", false), testid: "export-sheet-xlsx" },
    { icon: csv, label: "Šichtovnice CSV", hint: `${label} · pro mzdový program`, onClick: () => onPick("csv", false), testid: "export-sheet-csv" },
  ];
  if (canMoney) {
    items.push({ icon: money, label: `S částkami · ${label}`, testid: "export-pay-group", sub: [
      { icon: pdf, label: "Mzdy PDF", hint: "hrubá mzda orientačně, k tisku", onClick: () => onPick("pdf", true), testid: "export-pay-pdf" },
      { icon: xlsx, label: "Mzdy Excel", hint: "hodiny i částky pro účetní", onClick: () => onPick("xlsx", true), testid: "export-pay-xlsx" },
      { icon: csv, label: "Mzdy CSV", hint: "pro mzdový program", onClick: () => onPick("csv", true), testid: "export-pay-csv" },
    ] });
  }
  return items;
}
